// extracted by mini-css-extract-plugin
export default {"label":"Hamburger_label__bWjF-","input":"Hamburger_input__6aNpH"};